'use strict'

const unset_ = require('lodash/unset')

module.exports = ravenProxy => {
  const scopesMap = {}
  return {
    setScope: ({ componentId, itemId }, scope) => {
      ravenProxy.captureBreadcrumb({
        level: 'info',
        category: 'scopeStore',
        message: 'adding scope',
        data: { componentId, itemId }
      })
      scopesMap[componentId] = scopesMap[componentId] || {}
      scopesMap[componentId][itemId] = scope
    },
    getScope: ({ componentId, itemId }) => {
      const componentScopes = scopesMap[componentId]
      return componentScopes && componentScopes[itemId]
    },
    removeScope: ({ componentId, itemId }) => {
      ravenProxy.captureBreadcrumb({
        level: 'info',
        category: 'scopeStore',
        message: 'removing scope',
        data: { componentId, itemId }
      })
      const componentScopes = scopesMap[componentId]
      if (componentScopes) {
        componentScopes[itemId].dispose()
        unset_(componentScopes, itemId)
      }
    },
    getAll: () => {
      return Object.values(scopesMap).reduce(
        (acc, curr) => acc.concat(Object.values(curr)),
        []
      )
    }
  }
}



// WEBPACK FOOTER //
// ./dataset-controller/scopeStore.js